// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../vue3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../vue3/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../vue3/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4AWP4fwYAAs0BzPqkZckAAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.loading-bar-box {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999999;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  display: block;
  top: -100px !important;
}
.loading-bar {
  width: 320px;
  text-align: center;
  height: 160px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -80px;
  margin-left: -160px;
  background: #fff;
  border: 1px solid #999;
  -webkit-box-shadow: 0 0 18px rgba(0, 0, 0, 0.39);
  -moz-box-shadow: 0 0 18px rgba(0, 0, 0, 0.39);
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.39);
  color: #333;
}
.loading-icon {
  width: 38px;
  height: 38px;
  margin: 40px auto 10px;
}
`, "",{"version":3,"sources":["webpack://./../js/components/shared/LoadingBar.vue"],"names":[],"mappings":";AAiCA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,8DAA8I;EAC9I,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,gDAAgD;EAChD,6CAA6C;EAC7C,wCAAwC;EACxC,WAAW;AACb;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB","sourcesContent":["<!--\r\nIMPORTANT:\r\nThis file is used both in vue2 and vue3 application\r\nDont use vue syntax and store concept in this file\r\nFOr clarifications contact Leela\r\n-->\r\n<template>\r\n  <div>\r\n    <div class=\"loading-bar-box\">\r\n      <div class=\"loading-bar\">\r\n        <div class=\"loading-icon\">\r\n          <img src=\"https://i.gifer.com/4V0b.gif\" class=\"img-fluid\" alt=\"loading\" />\r\n        </div>\r\n        <div>{{ textdata }}</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</template>\r\n\r\n<script>\r\nexport default {\r\n  data() {\r\n    return {};\r\n  },\r\n  props: {\r\n    textdata: {\r\n      type: String,\r\n      default: \"Loading Please Wait\",\r\n    },\r\n  },\r\n};\r\n</script>\r\n<style @scoped>\r\n.loading-bar-box {\r\n  position: fixed;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 9999999;\r\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4AWP4fwYAAs0BzPqkZckAAAAASUVORK5CYII=) !important;\r\n  display: block;\r\n  top: -100px !important;\r\n}\r\n.loading-bar {\r\n  width: 320px;\r\n  text-align: center;\r\n  height: 160px;\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  margin-top: -80px;\r\n  margin-left: -160px;\r\n  background: #fff;\r\n  border: 1px solid #999;\r\n  -webkit-box-shadow: 0 0 18px rgba(0, 0, 0, 0.39);\r\n  -moz-box-shadow: 0 0 18px rgba(0, 0, 0, 0.39);\r\n  box-shadow: 0 0 18px rgba(0, 0, 0, 0.39);\r\n  color: #333;\r\n}\r\n\r\n.loading-icon {\r\n  width: 38px;\r\n  height: 38px;\r\n  margin: 40px auto 10px;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
